// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","272":"d3048c20","691":"component---src-pages-index-tsx","747":"component---src-components-templates-recipe-tsx"}[chunkId] + "-" + {"218":"01258d597a171a6c00c6","272":"f42713d7dec1b6ea4884","691":"1cb4bec613a6664a1c01","747":"f6bc7cea6b87372fc40d"}[chunkId] + ".js";
};